import { forwardRef, type InputHTMLAttributes, type TextareaHTMLAttributes } from "react";
import { cn } from "~/lib/cn";

const control =
  "w-full rounded-control border border-line-strong bg-surface px-3 text-fg placeholder:text-fg-3 transition-colors hover:border-fg-3 focus:border-gold focus:outline-none focus:ring-2 focus:ring-gold/30 disabled:cursor-not-allowed disabled:bg-surface-2 disabled:text-fg-3 aria-invalid:border-danger aria-invalid:focus:ring-danger/25";

export const Input = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(({ className, ...props }, ref) => (
  // 16px on touch screens prevents iOS from zooming into the field.
  <input ref={ref} className={cn(control, "h-9 text-sm max-md:h-11 max-md:text-base", className)} {...props} />
));
Input.displayName = "Input";

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaHTMLAttributes<HTMLTextAreaElement>>(
  ({ className, rows = 3, ...props }, ref) => (
    <textarea ref={ref} rows={rows} className={cn(control, "min-h-20 py-2 text-sm max-md:text-base", className)} {...props} />
  ),
);
Textarea.displayName = "Textarea";
